import React from 'react';

interface Props {
    heading: string;
    paragraph: string;
}

export default class BriefHero extends React.Component<Props> {
    render() {
        return (
            <div className="hero-layout">
                <div className="row">
                    <div className="column">
                        <h1 className="heading heading--h0 heading--with-divider heading--h0-capped">
                            {this.props.heading}
                        </h1>
                        <div className="spaced-items spaced-items--bottom-aligned">
                            <div className="spaced-items__item">
                                <p className="paragraph paragraph--narrow-widescreen paragraph--offset paragraph--no-margin">
                                    {this.props.paragraph}
                                </p>
                            </div>
                            <div className="spaced-items__item">
                                <img
                                    className="smartshoot-logo smartshoot-logo--responsive-alignment"
                                    src={require(`images/smartshoot/ss-logo-grey.png`)}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
